import React, { useEffect, useState,useRef } from "react";
import API from "../../services/api";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import { formatDatewithMonthReadable } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import {languageOptions,formatAmount,stateOptions} from "../../utils/constants";
import {slotPaymentTypeOptions} from "../../utils/constants";
import { SlSelect, SlOption } from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

const AlphaSalesCampaigns = ({team, date})=>{

    const [data,setdata]=useState([]);
    const [TotalPrice,setTotalPrice]=useState("");
    const [loader,setloader]=useState(false);
    const [downloader,setDownloader]=useState(false);
    const [stateFilter,setStateFilter]=useState("-1");
    const [stateDistrictIds,setStateDistrictIds]=useState([]);
    const [distNameMap,setDistNameMap]=useState({});
    const csvLinkRef = useRef();

    // Load a dist_id -> dist_name map once so the District column can be rendered
    // from each row's promoter dist_id (apr.dist_id). State filter is lang-1 only.
    useEffect(()=>{
      (async()=>{
        try{
          let res = await API({
            url:"/location/get-actual-districts",
            method:'POST',
            responseType:'json',
            data:{ lang_id: 1 }
          })
          if(res.code === 200){
            const map = {};
            (res.data || []).forEach((d)=>{ map[String(d.value)] = d.label; });
            setDistNameMap(map);
          }
        }catch(error){ console.error(error); }
      })();
    },[])

    // dist_id may be a single id or a comma separated string like "19,34".
    const resolveDistrict = (dist_id) =>
      String(dist_id ?? "")
        .split(",")
        .map((id)=> id.trim())
        .filter(Boolean)
        .map((id)=> distNameMap[id] || id)
        .join(", ");

    // When a state is selected, load the district ids that belong to it so we can
    // keep only the records whose dist_id falls under the selected state.
    useEffect(()=>{
      if(+stateFilter === -1){
        setStateDistrictIds([]);
        return;
      }
      const selectedState = stateOptions.find((s)=> +s.state_id === +stateFilter);
      if(!selectedState) return;
      (async()=>{
        try{
          let res = await API({
            url:"/location/getDistricts",
            method:'POST',
            responseType:'json',
            data:{ lang_id: selectedState.lang_id, state_id: selectedState.state_id }
          })
          if(res.code === 200)
            setStateDistrictIds(res.data.map((d)=> +d.dist_id));
        }catch(error){
          console.error(error);
        }
      })();
    },[stateFilter])

    // dist_id may be a single id or a comma separated string like "19,34" or
    // "34, 19" — keep the record if any of its dist ids falls under the state.
    const filteredData = +stateFilter === -1
      ? data
      : data.filter((row)=>
          String(row.dist_id ?? "")
            .split(",")
            .map((id)=> +id.trim())
            .some((id)=> stateDistrictIds.includes(id))
        );
    const filteredTotalPrice = +stateFilter === -1
      ? TotalPrice
      : filteredData.reduce((sum,row)=> sum + (parseFloat(row.spent) || 0), 0);
    
    const TomorrowRunningCampaigns = (reportType)=>{
      if(!filteredData.length)
      {
        toast.info("No data to Download");
        return;
      }
      setDownloader(true);
      csvLinkRef?.current?.link?.click();
      setTimeout(() => {
        setDownloader(false);
      }, 3000);
      }
      const Headers = [
        { label: "Date of Campaign", key: "start_date" },
        { label: "Team Name", key: "team" },
        { label: "Brand Name", key: "company_name" },
        { label: "District", key: "company_dist_name" },
        { label: "AD Placement", key: "ad_placement" },
        { label: "AD Location", key: "ad_location" },
        { label: "POS", key: "position" },
        { label: "AD Format", key: "sub_type" },
        { label: "24 Hours", key: "ser_24_hrs" },
        { label: "Price", key: "price" },
        { label: "Packages", key: "packages" },
        { label: "Package Weeks", key: "package_weeks" },
        { label: "New / Old.", key:"rank"},
        { label: "Txn Status", key: "txn_status" },
    ];
    
    const fetchData = async()=>{
        try{
            setloader(true);
            let res = await API({
                url:"/reports/campaignsRunningTomorrow",
                method:'POST',
                responseType:'json',
                data:{
                  team:+team,
                  date: date
                }
              })
              if(res.code === 200)
              {
                  setdata(res.data?.result);
                  setTotalPrice(res.data?.totalSalesPrice)
              }
              setloader(false);

        }catch(error)
        {
            console.error(error);
            setloader(false);
        }
    }
    useEffect(()=>{
      fetchData();
    },[date])

    return(
        <div>
        <div className="flex flex-col items-end">
        <sl-tooltip content="Download" hoist>
                    <sl-icon-button
                        library="lucide"
                        name="download"
                        onClick={() => {
                            TomorrowRunningCampaigns();
                        }}
                        className="top-4 right-4"
                    ></sl-icon-button>
        </sl-tooltip>
        <CSVLink
        data={[...filteredData.map(({
            start_date,
            company_name,
            team,
            dist_id,
            mandal_ids,
            district_ids,
            constituency_ids,
            state_ids,
            lang_ids,
            position,
            sub_type,
            campaign_type,
            cpd,
            daily_budget,
            payment_type,
            payment_details,
            package_type,
            lineitem_rank,
            package_weeks,
            payment_status,
            spent,
            ser_24_hrs
        })=>{
            const adPlacement = constituency_ids.length > 0
            ? "Constituency"
            : mandal_ids.length > 0
                ? "Mandal"
                : district_ids.length > 0
                ? "District"
                : state_ids.length > 0
                ? "State"
                : "Language";

            const adLocation =constituency_ids.length > 0
            ? constituency_ids.map(item => item.const_name || item.id).join(', ')
            : mandal_ids.length > 0
                ? mandal_ids.map(item => item.mandal_name || item.id).join(', ')
                :  district_ids.length > 0
                ? district_ids.map(item => item.dist_name || item.id).join(', ')
                : state_ids.length > 0
                ? state_ids.map(item => item.state_name || item.id).join(', ')
                : lang_ids.length > 0
                ? lang_ids.map(id => languageOptions.find(option => option.value === id)?.label).filter(Boolean).join(', ')
                : "No Data";

            return {
                start_date,
                team,
                company_name,
                company_dist_name: resolveDistrict(dist_id),
                ad_placement:adPlacement,
                ad_location:adLocation,
                position:+position,
                sub_type,
                ser_24_hrs: ser_24_hrs ? "Yes" : "No",
                price: spent,
                packages: package_type ? package_type : 'No',
                package_weeks: package_weeks ? `${package_weeks} Weeks (${lineitem_rank}/${package_weeks})` : '-',
                rank: package_type ? (+lineitem_rank === 1 ? 'New' : 'Old') : '-',
                txn_status: payment_status || '',
            };
        }),{
            start_date: "",
            team: "",
            company_name: "",
            company_dist_name:"",
            ad_placement: "",
            ad_location: "",
            position: "",
            sub_type: "TotalPrice",
            ser_24_hrs: "",
            price: parseFloat(filteredTotalPrice).toFixed(2),
            packages: "",
            package_weeks: "",
            rank:"",
            txn_status: "",
        }]}
        headers={Headers}
        filename="CentralizedAlphaSales.csv"
        ref={csvLinkRef}
        style={{ display: "none" }} // Hide from UI
        />
        </div>
        <div className="flex flex-col mb-3" style={{ maxWidth: "260px" }}>
          <label className="text-xs font-semibold mb-1.5 text-gray-700">State</label>
          <SlSelect
            placeholder="Select State"
            size="medium"
            value={stateFilter}
            onSlChange={(e)=> setStateFilter(e.target.value)}
          >
            <sl-icon library="lucide" name="globe" slot="prefix"></sl-icon>
            <SlOption value="-1">All States</SlOption>
            {stateOptions.filter((item)=> +item.lang_id === 1).map((item)=>(
              <SlOption key={item.state_id} value={`${item.state_id}`}>
                {item.state_name}
              </SlOption>
            ))}
          </SlSelect>
        </div>
        <div className="report-image">
        <ScrollContainer>
          <table  className='table table-bordered font-bold report-table'>
            <thead  className="!bg-blue-500 !text-white text-center">
              <tr>
                        <th>S.No</th>
                        <th>Date of Campaign</th>
                        <th>Team Name</th>
                        <th>Brand Name</th>
                        <th>District</th>
                        <th>AD Placement</th>
                        <th>AD Location</th>
                        <th>POS</th>
                        <th>AD Format</th>
                        <th>24 Hours</th>
                        <th>Price</th>
                        <th>Packages</th>
                        <th>Package Weeks</th>
                        <th>New / Old.</th>
                        <th>Txn Status</th>
            </tr>
            </thead>
            { filteredData.length > 0 ? (
                <tbody>
                    { filteredData.map((row,index)=>{
                      const date = formatDatewithMonthReadable(row.start_date);
                        return(
                        <tr>
                            <td>{index+1}</td>
                        <td style={{ whiteSpace: "nowrap" }}>{date}</td>
                        <td>{row.team}</td>
                        <td>{row.company_name}</td>
                        <td>{resolveDistrict(row.dist_id)}</td>
                        <td>
                            {
                             row.constituency_ids.length > 0
                             ? "Constituency"
                             :row.mandal_ids.length > 0
                            ? "Mandal"
                            :  row.district_ids.length > 0
                            ? "District"
                            : row.state_ids.length > 0
                            ? "State"
                            : "Language"
                            }
                        </td>
                        <td>
                        {
                             row.constituency_ids.length > 0
                             ? row.constituency_ids.map(item => item.const_name || item.id).join(', ') 
                             :row.mandal_ids.length > 0
                            ? row.mandal_ids.map(item => item.mandal_name || item.id).join(', ') 
                            : row.district_ids.length > 0
                            ? row.district_ids.map(item => item.dist_name || item.id).join(', ')  
                            : row.state_ids.length > 0
                            ? row.state_ids.map(item => item.state_name || item.id).join(', ')  
                            : row.lang_ids.length > 0
                            ? row.lang_ids.map(id => languageOptions.find(option => option.value === id)?.label)  
                            .filter(Boolean)
                            .join(', ')  
                        : "No Data"
                        }
                        </td>
                        <td>{row.position}</td>
                        <td>{row.sub_type}</td>
                        <td className="text-center">
                            <sl-tooltip content={`24 hours : ${row.ser_24_hrs ? 'true' : 'false'}`} hoist>
                                <sl-icon library="lucide" name={row.ser_24_hrs ? "clock-arrow-up" : "clock-fading"}></sl-icon>
                                <span className={row.ser_24_hrs ? 'text-amber-400' : 'text-gray-800'}>{row.ser_24_hrs ? 'yes' : 'no'}</span>
                            </sl-tooltip>
                        </td>
                        <td
                          title={row.spent}
                          style={{ whiteSpace: "nowrap" }}
                        >
                        ₹{(row.spent)}
                        </td>
                        <td>{row.package_type ? row.package_type : 'No'}</td>
                        <td className="!bg-orange-300">{row.package_weeks ? `${row.package_weeks} Weeks (${row.lineitem_rank}/${row.package_weeks})` : '-'}</td>
                        <td className="!bg-green-300">{row.package_type ? (+row.lineitem_rank === 1 ? 'New' : 'Old') : '-'}</td>
                        <td>{row.payment_status || '-'}</td>
                        </tr>
                        )
                    })
                }
            <tr>
                <td colSpan="10" className="px-4 py-2 text-center font-bold">Alpha Sales Total</td>
                <td colSpan="4" className="py-2 text-center font-bold !bg-yellow-200">{parseFloat(filteredTotalPrice).toFixed(2)}</td>
            </tr>
          </tbody>
            ): !filteredData.length && !loader ? (<NoDataFound colspan="12" />):<TableLoader colspan="12"/>
            }
          </table>
        </ScrollContainer>
        </div>
    </div>
    )
}
export default AlphaSalesCampaigns;
